import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/clients',
    name: 'Clients',
    component: () => import('../views/ClientView.vue')
  },
  {
    path: '/generate',
    name: 'Generate',
    component: () => import('../views/GenerateView.vue')
  },
  {
    path: '/edit-client/:id',
    name: 'EditClient',
    component: () => import('../views/EditClientView.vue')
  },
  {
    path: '/download',
    name: 'Download',
    component: () => import('../views/DownloadView.vue')
  },
  {
    path: '/support',
    name: 'Support',
    component: () => import('../views/SupportView.vue')
  },
  {
    path: '/tutorial',
    name: 'Tutorial',
    component: () => import('../views/AboutView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
